// extracted by mini-css-extract-plugin
export default {"lazy":"O2gflvZ","show":"moazNFa"};